export default __webpack_public_path__ + "static/media/press_room_thumb_modal4.3be77a16.jpg";